import React from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Paper from "@material-ui/core/Paper";
import EditorComponent from "./editor";
import Fase1 from "./Fases/Fase1";
import Fase2 from "./Fases/Fase2";
import Fase3Merc from "./Fases/Fase3Merc";
import Fase3Oral from "./Fases/Fase3Oral";

class Switcher extends React.Component {
  render() {
    switch (this.props.index) {
      case 0:
        return (
          <EditorComponent
            selectedNote={this.props.selectedNote}
            noteUpdate={this.props.noteUpdate}
            index={this.props.selectedNoteIndex}
            datosAutoc={this.props.datosAutoc}
            notes={this.props.notes}
            usuarios={this.props.usuarios}
          />
        );
      case 1:
        return (
          <Fase1
            selectedNote={this.props.selectedNote}
            index={this.props.selectedNoteIndex}
            notes={this.props.notes}
          />
        );
      case 2:
        return (
          <Fase2
            selectedNote={this.props.selectedNote}
            datosAutoc={this.props.datosAutoc}
            index={this.props.selectedNoteIndex}
            notes={this.props.notes}
          />
        );
      case 3:
        return (
          <div>
            <SubSwitch
              selectedNote={this.props.selectedNote}
              datosAutoc={this.props.datosAutoc}
              index={this.props.selectedNoteIndex}
              notes={this.props.notes}
            />
          </div>
        );
      default:
        return <div></div>;
    }
  }
}

function SubSwitch(props) {
  const [value, setValueC] = React.useState(0);

  function handleChange(event, newValue) {
    setValueC(newValue);
  }

  return (
    <div>
      <Paper square>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="secondary"
          textColor="primary"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab label="Oral Mercantil" onClick={() => setValueC(0)} />
          <Tab label="Ordinaria Mercantil" onClick={() => setValueC(1)} />
        </Tabs>
      </Paper>
      <div>
        {value === 0 ? (
          <div>
            <Fase3Oral
              selectedNote={props.selectedNote}
              datosAutoc={props.datosAutoc}
              index={props.index}
              notes={props.notes}
            />
          </div>
        ) : (
          <div>
            <Fase3Merc
              selectedNote={props.selectedNote}
              datosAutoc={props.datosAutoc}
              index={props.index}
              notes={props.notes}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default Switcher;
